module.exports = __webpack_public_path__ + "img/Icon_orders.ba36e315.svg";